export default __webpack_public_path__ + "static/casecard2-baaa5d8bac36b1e9b45d5c051f1f8b29.png";